export const AvailableBrands = [
    'amex',
    'dinners',
    'visa',
    'mastercard',
    'maestro',
    'discover',
    'hipercard',
    'elo',
    'jcb',
    'aura',
    'electron',
    'unionpay',
    'laser',
    'hiper',
    'visaelectron'
];



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/enums/AvailableBrands.ts